import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { Box, styled } from '@mui/material';
import { BasicAlert, IValidationError } from '@ngt/forms';
import { useFormErrorBoundary } from '@ngt/forms-core';
import { FunctionComponent } from 'react';
import ToggleFeedbackButton from './error/ToggleFeedbackButton';

interface IFormErrorDisplayProps {
    title?: string;
    className?: string;
}

const Pre = styled('pre')(({theme }) => ({
    margin: 0,
    padding: 0,
    width: '100%',
    overflow: 'auto'
}));

const FormErrorDisplay: FunctionComponent<IFormErrorDisplayProps> = ({
    title,
    className
}) => {
    const errors = useFormErrorBoundary<any, IValidationError>();
  
    if (!errors || errors.length === 0) {
        return null;
    }

    const errorView = errors.map((error, i) => (
        <Pre key={i}>
            {error.message}
        </Pre>
    ))
    return (
        <>
            <Box sx={{ mb: 2}}>
                <BasicAlert
                    severity="error"
                    title={title ?? 'Error'}
                    description={errorView}
                    icon={faExclamationTriangle}
                />
            </Box>
            <Box>
                <ToggleFeedbackButton/>
            </Box>
        </>
    )
};

export default FormErrorDisplay;